import v from "./highrise990.mjs";
import x from "./highrise987.mjs";
function h(l) {
  const {
    primaryColor: t,
    borderRadius: r,
    lineHeight: d,
    fontSize: o,
    cardColor: c,
    textColor2: i,
    textColor1: n,
    dividerColor: a,
    fontWeightStrong: s,
    closeIconColor: C,
    closeIconColorHover: m,
    closeIconColorPressed: f,
    closeColorHover: b,
    closeColorPressed: g,
    modalColor: S,
    boxShadow1: p,
    popoverColor: u,
    actionColor: e
  } = l;
  return Object.assign(Object.assign({}, v), {
    lineHeight: d,
    color: c,
    colorModal: S,
    colorPopover: u,
    colorTarget: t,
    colorEmbedded: e,
    colorEmbeddedModal: e,
    colorEmbeddedPopover: e,
    textColor: i,
    titleTextColor: n,
    borderColor: a,
    actionColor: e,
    titleFontWeight: s,
    closeColorHover: b,
    closeColorPressed: g,
    closeBorderRadius: r,
    closeIconColor: C,
    closeIconColorHover: m,
    closeIconColorPressed: f,
    fontSizeSmall: o,
    fontSizeMedium: o,
    fontSizeLarge: o,
    fontSizeHuge: o,
    boxShadow: p,
    borderRadius: r
  });
}
const P = {
  name: "Card",
  common: x,
  self: h
};
export {
  P as default,
  h as self
};
